"use strict";

exports.__esModule = true;
var _FontPicker = require("./FontPicker");
Object.keys(_FontPicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FontPicker[key]) return;
  exports[key] = _FontPicker[key];
});